/**
 * @param {boolean} testFinalizado
 * @returns {'confirmExit' | 'leaveResults'}
 */
export function resolveTestExitAction(testFinalizado) {
  return testFinalizado ? 'leaveResults' : 'confirmExit';
}

/**
 * @param {boolean} testFinalizado
 * @returns {boolean}
 */
export function shouldShowFinishTestButton(testFinalizado) {
  return !testFinalizado;
}

/**
 * @param {boolean} testFinalizado
 * @returns {boolean}
 */
export function shouldShowFinishConfirmModal(testFinalizado, showFinishConfirm) {
  return showFinishConfirm && !testFinalizado;
}

/**
 * @param {boolean} testFinalizado
 * @returns {boolean}
 */
export function shouldShowExitConfirmModal(testFinalizado, showExitConfirm) {
  return showExitConfirm && !testFinalizado;
}
